<fuse-loading-bar></fuse-loading-bar>

<fuse-vertical-navigation
    class="mzeit-navigation dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation?.default || []"
    [opened]="!isScreenSmall"
>
    <ng-container fuseVerticalNavigationContentHeader>
        <a class="mzeit-brand" routerLink="/dashboard" [attr.aria-label]="'navigation.dashboard' | transloco">
            <span class="mzeit-brand-logo" role="img" aria-label="M-Zeit"></span>
        </a>
        <div class="mzeit-tenant">
            <span>{{ 'layout.inUseBy' | transloco }}</span>
            <strong>{{ appearance.displayName() }}</strong>
        </div>
    </ng-container>
    <ng-container fuseVerticalNavigationContentFooter>
        @if (tenantLogo.url()) {
            <div class="mzeit-company-logo"><img [src]="tenantLogo.url()" alt="Firmenlogo" /></div>
        }
    </ng-container>
    <ng-container fuseVerticalNavigationFooter>
        <div class="mzeit-sidebar-user">
            <user [showAvatar]="true"></user>
            <div class="mzeit-user-name">
                <strong>{{ user.firstName }} {{ user.lastName }}</strong>
                @if (roleName) { <span class="mzeit-user-role" [title]="roleName">{{ roleName }}</span> }
                <span [title]="user.userName">{{ user.userName }}</span>
            </div>
            <notifications></notifications>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<div class="mzeit-layout-content">
    @if (appearance.preferences.error()) {
        <div role="alert" class="px-6 py-3 bg-card text-secondary">
            {{ appearance.preferences.error() }}
            <button type="button" class="underline ml-3" (click)="appearance.preferences.reload()">{{ 'workTimeRequests.refresh' | transloco }}</button>
        </div>
    }
    <header class="mzeit-topbar bg-card print:hidden">
        <button
            mat-icon-button
            type="button"
            (click)="toggleNavigation('mainNavigation')"
            [attr.aria-label]="'layout.toggleNavigation' | transloco"
        >
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <a class="mzeit-topbar-brand" routerLink="/dashboard" aria-label="M-Zeit" title="M-Zeit - ein Produkt der Mittelstandssoftware.de GmbH">
            <span class="brand-full">
                <strong class="brand-product">M-Zeit</strong>
                <span class="brand-publisher">ein Produkt der <span>Mittelstandssoftware.de GmbH</span></span>
            </span>
            <span class="brand-mobile" aria-hidden="true"><span class="brand-mobile-mark"></span><span>-Zeit</span></span>
        </a>
        <div class="mzeit-header-tools">
            <a class="desktop-header-action" mat-icon-button routerLink="/dashboard" [attr.aria-label]="'headerLinks.home' | transloco" [matTooltip]="'headerLinks.home' | transloco">
                <mat-icon svgIcon="heroicons_outline:home"></mat-icon>
            </a>
            <a mat-icon-button routerLink="/help" [attr.aria-label]="'headerLinks.help' | transloco" [matTooltip]="'headerLinks.help' | transloco">
                <mat-icon svgIcon="heroicons_outline:question-mark-circle"></mat-icon>
            </a>
            <button class="desktop-header-action" mat-icon-button type="button" aria-disabled="true" [attr.aria-label]="'headerLinks.contact' | transloco" [matTooltip]="'headerLinks.contactPlanned' | transloco">
                <mat-icon svgIcon="heroicons_outline:chat-bubble-left-right"></mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="toggleColorScheme()"
                [attr.aria-label]="(isDark ? 'headerLinks.lightMode' : 'headerLinks.darkMode') | transloco"
                [matTooltip]="(isDark ? 'headerLinks.lightMode' : 'headerLinks.darkMode') | transloco">
                <mat-icon [svgIcon]="isDark ? 'heroicons_outline:sun' : 'heroicons_outline:moon'"></mat-icon>
            </button>
            <languages></languages>
        </div>
        <app-time-tracking-bar class="mzeit-header-time"></app-time-tracking-bar>
    </header>
    <div class="mzeit-page">
        <router-outlet></router-outlet>
    </div>
</div>
